module.exports = __webpack_public_path__ + "static/media/hampster-1.58627051.mp3";